import { useStore } from "vuex";

export function useCurrentTerminal() {
	const store = useStore();

	const currentTerminal = computed(() => {
		const manualCurrentTerminal = store.state.manualCurrentTerminal;
		const terminals = store.getters["checkout/terminals"];

		return (
			manualCurrentTerminal ||
			terminals?.find((terminal) => !terminal?.metadata?.terminalConfigured && terminal?.type === "hardware")
		);
	});

	return { currentTerminal };
}
